import React, { useContext } from 'react';
import { LoadingContext } from '../LoadingContext';
import './Loading.css';

const Loading = () => {
  const { isLoading } = useContext(LoadingContext);

  if (!isLoading) {
    return null;
  }

  return (
    <div className="loading-overlay">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default Loading;